import { render, staticRenderFns } from "./Sharing-Management.vue?vue&type=template&id=2601078b&scoped=true&"
import script from "./Sharing-Management.vue?vue&type=script&lang=js&"
export * from "./Sharing-Management.vue?vue&type=script&lang=js&"
import style0 from "./Sharing-Management.vue?vue&type=style&index=0&id=2601078b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2601078b",
  null
  
)

export default component.exports